import { Alert } from '@fluentui/react-northstar';
import { ExclamationTriangleIcon } from '@fluentui/react-icons-northstar'
import { useTranslation } from 'react-i18next';

interface ErrorAlertProps {
    message: string;
    compact?: boolean;
}

const ErrorAlert = (props: ErrorAlertProps) => {
    const { message, compact } = props;
    const { t } = useTranslation();

    return (<div
        style={{ marginTop: compact ? 0 : 30 }}>
        <Alert
            content={message ? t(message) : ''}
            header={compact ? undefined : t("Error.Header")}
            danger
            style={{ padding: compact ? 10 : 20 }}
            icon={compact ? undefined : <ExclamationTriangleIcon />}
        />
    </div>);
}

export default ErrorAlert;